/**
 * Adzuki. My Settings - Certifications tag list
 *
 * SET-17. The control underneath stays production's multiple <select>, because that is what
 * carries the value and what the form posts. These chips are a SECOND VIEW of the same
 * selection, not a replacement for it.
 *
 * WHY THEY EARN THEIR PLACE: form.js initialises bootstrap-select with
 * selectedTextFormat: 'count', so a multi-select collapses to "3 selected" - which tells the
 * advisor how many certifications they hold and not which. The chips say which, and let one be
 * removed without opening the dropdown and hunting for it.
 *
 * ONE SOURCE OF TRUTH. The chips are always rendered FROM the select's own selected options,
 * never from a list this file keeps - so a change made in the dropdown and a chip removed here
 * cannot disagree. Removing a chip deselects the option and re-renders from the select again.
 *
 * DELEGATED FROM document AND BOUND ONCE, the same shape as the shipping and shortcuts panels:
 * the panel is replaced on every render, so there is nothing to bind to at ready, and binding
 * per render is how handlers get attached twice.
 */

(function MySettingsCertifications($, Adzuki)
{
	"use strict";

	var _render,
	    _renderAll,
	    _sourceFor;

	/**
	 * The select a tag list belongs to.
	 *
	 * BY ID RATHER THAN BY PROXIMITY, because the markup puts the list inside the field control
	 * beside the select and a structural lookup would break the moment that layout changes.
	 */
	_sourceFor = function sourceFor($list)
	{
		var id = $list.attr('data-my-settings-tags-for');

		return (id ? $('#' + id) : $());
	};

	/**
	 * Draws one tag list from its select's selected options.
	 */
	_render = function render($list)
	{
		var $source = _sourceFor($list);
		var items   = [];

		if (!$source.length) {
			return;
		}

		$source.find('option:selected').each(function collect() {
			var $option = $(this);

			// bootstrap-select can carry a placeholder option; an empty value is not a tag
			if (!$option.val()) {
				return;
			}

			items.push({
				value: $option.val(),
				label: $.trim($option.text())
			});
		});

		$list.empty();

		// EMPTY RATHER THAN A PLACEHOLDER. The select beside it already says "Nothing selected",
		// so a second empty-state message would be the same sentence twice.
		$.each(items, function addTag(i, item) {
			var $tag    = $('<li>', { class: 'my-settings-tag' });
			var $label  = $('<span>', {
				class: 'my-settings-tag-label',
				text : item.label
			});
			var $remove = $('<button>', {
				type                        : 'button',
				class                       : 'my-settings-tag-remove',
				'aria-label'                : 'Remove ' + item.label,
				'data-my-settings-tag-value': item.value
			});

			$tag.append($label).append($remove);
			$list.append($tag);
		});
	};

	_renderAll = function renderAll()
	{
		$('.my-settings-overlay .my-settings-tags').each(function eachList() {
			_render($(this));
		});
	};

	$(document).ready(function documentReady() {
		$(document).on('click', '.my-settings-overlay [data-my-settings-tag-value]', function removeTag(e) {
			var $button = $(this);
			var $list   = $button.closest('.my-settings-tags');
			var $source = _sourceFor($list);
			var value   = $button.attr('data-my-settings-tag-value');

			e.preventDefault();

			if (!$source.length) {
				return;
			}

			$source.find('option').filter(function isThisOne() {
				return $(this).val() === value;
			}).prop('selected', false);

			// bootstrap-select draws its own summary from the select, so it has to be told
			if ($.fn.selectpicker) {
				$source.selectpicker('refresh');
			}

			// AND THE PAGE HAS TO BE TOLD TOO. The dirty tracker listens for change/input on the
			// fields that post; a selection changed by script fires nothing on its own, so
			// without this the advisor could remove a certification and not be able to save it.
			$source.trigger('change');

			_render($list);
		});

		// the dropdown is the other way in, and the chips follow it
		$(document).on('changed.bs.select', '.my-settings-overlay .my-settings-tags-source, .my-settings-overlay select[multiple]', function sourceChanged() {
			var id = $(this).attr('id');

			if (!id) {
				return;
			}

			_render($('.my-settings-tags[data-my-settings-tags-for="' + id + '"]'));
		});

		// a fresh panel needs its chips drawn from the markup that just arrived
		$(document).on('my-settings:rendered', function panelRendered() {
			_renderAll();
		});
	});
}(jQuery, window.Adzuki || {}));
